import { useMutation } from "@tanstack/react-query";
import { submitPublicationRequest, type PublicationRequestDto } from "../api/publicationRequestsApi";

export function useSubmitPublicationRequest() {
  return useMutation({
    mutationFn: (dto: PublicationRequestDto) => submitPublicationRequest(dto),
  });
}
